import React, { useEffect, useState, useContext } from 'react';
import Highlight from 'react-highlight';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Card, CardBody, CardHeader, CardHeaderBtn } from './../../components/card/card.jsx';
import { AppSettings } from './../../config/app-settings.js';

function LayoutFullHeight() {
	const context = useContext(AppSettings);
	const [code1, setCode1] = useState();
	
	useEffect(() => {
		fetch('/quantum-react/assets/data/layout/full-height-code-1.json').then(function(response) { return response.text(); }).then((html) => { setCode1(html); });
		
		context.setAppContentFullHeight(true);
		context.setAppContentClass('p-0');
		
		return function cleanup() {
			context.setAppContentFullHeight(false);
			context.setAppContentClass('');
		}
		// eslint-disable-next-line
	}, []);
	
	return (
		<PerfectScrollbar className="app-content-inner-padding h-100">
			<ul className="breadcrumb">
				<li className="breadcrumb-item"><a href="#/">LAYOUT</a></li>
				<li className="breadcrumb-item active">FULL HEIGHT</li>
			</ul>
			
			<h1 className="page-header">
				Full Height <small>page header description goes here...</small>
			</h1>
			
			<Card className="mb-3">
				<CardHeader className="with-btn">
					INSTALLATION
					<CardHeaderBtn />
				</CardHeader>
				<CardBody>
					<p>
					Add the following code for full height page setting.
					</p>
				</CardBody>
				<div className="hljs-container">
					<Highlight className='javascript'>{code1}</Highlight>
				</div>
			</Card>
			
			<div>
				Content Area with scrollbar. Try to scroll down. <i className="fa fa-arrow-down text-theme"></i>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				<p>&nbsp;</p>
				You got the bottom
			</div>
		</PerfectScrollbar>
	)
}

export default LayoutFullHeight;